import * as React from 'react'

import { observer } from 'mobx-react'
import { IProductList } from 'src/models/product'
import trans from '../utils/translations'

class ProductFilters extends React.Component<{ productList: IProductList }, {}> {
    minPrice = ''
    maxPrice = ''

    priceChangeTimer: any

    private handleCategorieSelect(optionId: number) {
        const { productList } = this.props
        productList.toggleCategory(optionId)
    }

    private handleSpecificationSelect(optionId: number) {
        const { productList } = this.props
        productList.toggleSpecification(optionId)
    }

    private handleBedroomsSelect(optionId: number) {
        const { productList } = this.props
        productList.toggleBedroom(optionId)
    }

    private handleLocationsSelect(optionId: number) {
        const { productList } = this.props
        productList.toggleLocation(optionId)
    }

    private handleBrandsSelect(optionId: number) {
        const { productList } = this.props
        productList.toggleBrand(optionId)
    }

    private handleTypesSelect(optionId: number) {
        const { productList } = this.props
        productList.toggleType(optionId)
    }

    private handleMinPrice(e: any) {
        const { productList } = this.props
        const price = Math.abs(parseInt(e.target.value))
        productList.setMinPrice(!isNaN(price) ? price : null)
    }

    private handleMaxPrice(e: any) {
        const { productList } = this.props
        const price = Math.abs(parseInt(e.target.value))
        productList.setMaxPrice(!isNaN(price) ? price : null)
    }

    public render() {
        const { productList } = this.props
        return (
            <div>
                <div className="filter-block">
                    <div className={'title'}>{trans.t('Categorieën')}</div>
                    {productList.filterCategories.map((option, idx) => (
                        <div key={idx}>
                            <label>
                                <input
                                    type="checkbox"
                                    onChange={() => {
                                        this.handleCategorieSelect(option.id)
                                    }}
                                    checked={option.selected}
                                    value={option.id}
                                />
                                <span>{option.title}</span>
                            </label>
                        </div>
                    ))}
                </div>
                <div className="filter-block">
                    <div className={'title'}>{trans.t('Specificaties')}</div>
                    {productList.filterSpecifications
                        .filter(option => option.show)
                        .map((option, idx) => (
                            <div key={idx}>
                                <label>
                                    <input
                                        type="checkbox"
                                        onChange={() => {
                                            this.handleSpecificationSelect(option.id)
                                        }}
                                        checked={option.selected}
                                        value={option.id}
                                    />
                                    <span>{option.title}</span>
                                </label>
                            </div>
                        ))}
                </div>
                <div className="filter-block">
                    <div className={'title'}>{trans.t('Slaapkamers')}</div>
                    {productList.filterBedrooms.map((option, idx) => (
                        <div key={idx}>
                            <label>
                                <input
                                    type="checkbox"
                                    onChange={() => {
                                        this.handleBedroomsSelect(option.id)
                                    }}
                                    checked={option.selected}
                                    value={option.id}
                                />
                                <span>{option.title}</span>
                            </label>
                        </div>
                    ))}
                </div>
                <div className="filter-block">
                    <div className={'title'}>{trans.t('Vestigingen')}</div>
                    {productList.filterLocations.map((option, idx) => (
                        <div key={idx}>
                            <label>
                                <input
                                    type="checkbox"
                                    onChange={() => {
                                        this.handleLocationsSelect(option.id)
                                    }}
                                    checked={option.selected}
                                    value={option.id}
                                />
                                <span>{option.title}</span>
                            </label>
                        </div>
                    ))}
                </div>
                <div className="filter-block">
                    <div className={'title'}>{trans.t('Prijs')}</div>
                    <span className={'numberlabel'}>€ </span>
                    <input
                        type="text"
                        onChange={e => {
                            this.handleMinPrice(e)
                        }}
                        value={productList.inputFieldMinPrice || ''}
                    />{' '}
                    <span className={'numberlabel'}>{trans.t('Tot:')}</span>
                    <input
                        type="text"
                        onChange={e => {
                            this.handleMaxPrice(e)
                        }}
                        value={productList.inputFieldMaxPrice || ''}
                    />
                </div>
                <div className="filter-block">
                    <div className={'title'}>{trans.t('Merk')}</div>
                    {productList.filterBrands.map((option, idx) => (
                        <div key={idx}>
                            <label>
                                <input
                                    type="checkbox"
                                    onChange={() => {
                                        this.handleBrandsSelect(option.id)
                                    }}
                                    checked={option.selected}
                                    value={option.id}
                                />
                                <span>{option.title}</span>
                            </label>
                        </div>
                    ))}
                </div>
                {productList.filterTypes.length > 0 && (
                    <div className="filter-block">
                        <div className={'title'}>{trans.t('Type')}</div>
                        {productList.filterTypes.map((option, idx) => (
                            <div key={idx}>
                                <label>
                                    <input
                                        type="checkbox"
                                        onChange={() => {
                                            this.handleTypesSelect(option.id)
                                        }}
                                        checked={option.selected}
                                        value={option.id}
                                    />
                                    <span>{option.title}</span>
                                </label>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        )
    }
}

export default observer(ProductFilters)



// WEBPACK FOOTER //
// ./react/src/components/ProductFilters.tsx